import { apiFetch } from '../../../shared/services/apiClient';
import {
  FiltrosProveedor,
  PaginacionProveedores,
  ProveedorDetalle,
  CreateProveedorAdminPayload,
  UpdateProveedorAdminPayload,
} from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function handleResponse<T>(res: Response): Promise<T> {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body.error || `HTTP ${res.status}`);
  }
  return body.data ?? body;
}

export const proveedorAdminService = {
  async listar(filtros: FiltrosProveedor = { pagina: 1, limite: 10 }): Promise<PaginacionProveedores> {
    const params = new URLSearchParams();
    params.set('pagina', String(filtros.pagina));
    params.set('limite', String(filtros.limite));
    if (filtros.busqueda) params.set('busqueda', filtros.busqueda);
    const res = await apiFetch(`${API_BASE}/proveedores/admin?${params}`);
    return handleResponse<PaginacionProveedores>(res);
  },

  async obtener(id: number): Promise<ProveedorDetalle> {
    const res = await apiFetch(`${API_BASE}/proveedores/admin/${id}`);
    return handleResponse<ProveedorDetalle>(res);
  },

  async crear(payload: CreateProveedorAdminPayload): Promise<ProveedorDetalle> {
    const res = await apiFetch(`${API_BASE}/proveedores/admin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return handleResponse<ProveedorDetalle>(res);
  },

  async actualizar(id: number, payload: UpdateProveedorAdminPayload): Promise<ProveedorDetalle> {
    const res = await apiFetch(`${API_BASE}/proveedores/admin/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return handleResponse<ProveedorDetalle>(res);
  },

  async eliminar(id: number): Promise<void> {
    const res = await apiFetch(`${API_BASE}/proveedores/admin/${id}`, { method: 'DELETE' });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || `HTTP ${res.status}`);
    }
  },
};
